import React from "react";

/**
 * OnboardingQuestion — one Duolingo-style single-choice screen.
 * Tapping an option advances immediately (no separate Continue button).
 */
export default function OnboardingQuestion({ question, value, onSelect }) {
  return (
    <div className="w-full">
      <h2 className="text-xl sm:text-2xl font-semibold text-dt-parchment mb-1.5">
        {question.title}
      </h2>
      {question.subtitle && (
        <p className="text-sm text-dt-parchment-dim mb-5">{question.subtitle}</p>
      )}
      <div className="flex flex-col gap-2.5">
        {question.options.map((opt) => {
          const selected = value === opt.value;
          return (
            <button
              key={String(opt.value)}
              type="button"
              onClick={() => onSelect(opt.value)}
              className={`surface surface--interactive text-left rounded-xl px-4 py-3.5 min-h-[44px] transition-colors ${
                selected ? "ring-1" : ""
              }`}
              style={selected ? { borderColor: "var(--gold)", boxShadow: "0 0 0 1px var(--gold)" } : undefined}
            >
              <span className="flex items-center justify-between gap-3">
                <span>
                  <span className="block text-[15px] font-medium text-dt-parchment">
                    {opt.label}
                  </span>
                  {opt.description && (
                    <span className="block text-xs text-dt-parchment-dim mt-0.5">
                      {opt.description}
                    </span>
                  )}
                </span>
                {opt.arabic && (
                  <span dir="rtl" lang="ar" className="font-amiri text-xl text-dt-gold-bright shrink-0">
                    {opt.arabic}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
